import { useState } from 'react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;

    console.log('Password reset requested for:', email);
    setSubmitted(true);

    // Reset after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setEmail('');
    }, 3000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {submitted ? (
        <div className="p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-lg">
          <p className="text-sm font-medium text-emerald-800 dark:text-emerald-300">
            ✓ Check your email for reset instructions
          </p>
          <p className="text-xs text-emerald-700 dark:text-emerald-400 mt-1">
            If no email arrives, check your spam folder or contact support.
          </p>
        </div>
      ) : (
        <>
          <div>
            <label htmlFor="reset-email" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
              Email Address
            </label>
            <input
              id="reset-email"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white dark:bg-gray-800 border border-slate-300 dark:border-slate-700 rounded-lg px-4 py-2 text-slate-900 dark:text-white placeholder-gray-400 dark:placeholder-slate-500 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <p className="text-xs text-slate-600 dark:text-slate-400">
            Enter the email associated with your account and we'll send you a link to reset your password.
          </p>

          <button
            type="submit"
            disabled={!email}
            className="w-full mt-4 bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700 disabled:bg-slate-400 text-white font-semibold rounded-lg py-2 px-4 transition-colors shadow-md hover:shadow-lg disabled:shadow-none"
          >
            Send reset link
          </button>
        </>
      )}
    </form>
  );
}

